import type { ReportPage } from "./types";

type NavigationPage = Pick<ReportPage, "id" | "parentPageId" | "showInNavigation">;

export function navigationHeaderPage(pages: NavigationPage[], pageId: string): string {
  let current = pages.find((page) => page.id === pageId);
  const seen = new Set<string>();
  while (current?.parentPageId && !seen.has(current.id)) {
    seen.add(current.id);
    const parent = pages.find((page) => page.id === current?.parentPageId);
    if (!parent || (!parent.parentPageId && current.showInNavigation !== false)) break;
    current = parent;
  }
  return current?.id ?? pageId;
}

export function isHeaderPage(pages: NavigationPage[], page: NavigationPage): boolean {
  return page.showInNavigation !== false && navigationHeaderPage(pages, page.id) === page.id;
}
